<template>
    <div>
        <!-- <a-form layout="inline">
            <a-form-item label="标题">
                <a-input v-model="keywords" type="text" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary">查询</a-button>
            </a-form-item>
        </a-form> -->
        <a-button @click="$refs.bannerInfo.show()" type="primary">
            <a-icon type="plus" />
            {{ $t('web.new' /* 新增 */) }}
        </a-button>

        <a-table class="mt15" size="middle" :custom-row="customRow" :pagination="false" :rowKey="record => record.id" :data-source="dataSource" :columns="columns" :scroll="{ x: 700 }">
            <template slot="drag" slot-scope="text, record">
                <i class="medcon fs24 med-Drag"></i>
            </template>
            <template slot="img" slot-scope="text, record">
                <img style="width: 50px; height: 50px; object-fit: cover" :src="record.pic_url | urlFilter(250)" alt="" />
            </template>
            <template slot="create_time" slot-scope="text, record">
                {{ (record.create_time * 1000) | formatDate }}
            </template>
            <template slot="edit" slot-scope="text, record">
                <a-button @click="$refs.bannerInfo.show(record)" type="primary" size="small">{{ $t('web.edit' /* 编辑 */) }}</a-button>
                <a-button type="danger" @click="deleteBanner(record)" class="ml10" size="small">{{ $t('web.delete' /* 删除 */) }}</a-button>
            </template>
        </a-table>
        <banner-info :getContainer="getContainer" @refresh="getList" ref="bannerInfo"></banner-info>
    </div>
</template>

<script>
import tableDrag from '@/utils/table.drag.mixins.js';
import bannerInfo from './components/banner-info.vue';
export default {
    name: 'MobileConfigBanner',
    mixins: [tableDrag],
    components: { bannerInfo },
    props: {},
    data() {
        return {
            columns: [
                {
                    title: this.$t('web.sort' /* 排序 */),
                    scopedSlots: { customRender: 'drag' }
                },
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'center'
                },
                {
                    title: this.$t('mobileConfig.banner_title' /* 标题 */),
                    dataIndex: 'title',
                    align: 'center'
                },
                {
                    title: this.$t('mobileConfig.banner_image' /* 图片 */),
                    scopedSlots: { customRender: 'img' },
                    align: 'center'
                },
                {
                    title: this.$t('web.sort' /* 排序 */),
                    dataIndex: 'sort',
                    align: 'center'
                },
                {
                    title: this.$t('mobileConfig.banner_create_time' /* 创建时间 */),
                    scopedSlots: { customRender: 'create_time' },
                    align: 'center'
                },
                {
                    title: this.$t('web.actions' /* 操作 */),
                    width: 150,
                    scopedSlots: { customRender: 'edit' },
                    align: 'center',
                    fixed: 'right'
                }
            ],
            dataSource: [],
            visible: false,
            loading: true,

            getContainer: () => document.getElementsByClassName('ant-drawer-content-wrapper')[0],

            // 搜索内容
            keywords: '',
            language: 'cn'
        };
    },
    created() {
        this.language = window.location.hash.match(/(cn|en)/g)[0];
        this.getList();
    },
    methods: {
        getList() {
            this.loading = true;
            let data = {
                language: this.language
            };
            this.$request.get({ url: 'getMobileBanners', data }).then(res => {
                this.dataSource = res.data.data;
                this.loading = false;
            });
        },
        // 显示
        show(title, module_id) {
            this.visible = true;
            this.$nextTick(() => {
                this.loading = false;
            });
        },
        deleteBanner(item) {
            this.$confirm({
                title: this.$t('web.tips' /* 提示 */),
                content: this.$t('mobileConfig.banner_confirm_delete' /* 确定删除该banner吗？ */),
                okText: this.$t('web.ok' /* 确定 */),
                cancelText: this.$t('web.cancel' /* 取消 */),
                onOk: () => {
                    let data = {
                        id: item.id,
                        language: this.language
                    };
                    this.$request.post({ url: 'deleteMobileBanner', data }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(this.$t('web.delete_success' /* 删除成功 */));
                            this.getList();
                        }
                    });
                }
            });
        },
        // 关闭
        onClose() {
            this.visible = false;
        },
        // 拖拽成功方法
        dragSuccess() {
            console.log('拖拽成功');
        }
    },
    mounted() {}
};
</script>

<style lang="less" scoped>
#imageDrawer {
    /deep/.ant-modal-wrap {
        position: absolute;
    }
}
</style>
